var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProgressCheckmark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.795 9.853l-9.547 9.214-2.533-2.707c-.466-.44-1.2-.466-1.733-.093-.52.387-.667 1.067-.347 1.613l3 4.88c.293.453.8.733 1.373.733a1.63 1.63 0 001.36-.733c.48-.627 9.64-11.547 9.64-11.547 1.2-1.226-.253-2.306-1.213-1.373v.013z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProgressCheckmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/progressCheckmark.b7f3dffda4882017f57a01fc1ec60219.svg";